import { render, staticRenderFns } from "./multy-check.vue?vue&type=template&id=fd96a5c8&"
import script from "./multy-check.vue?vue&type=script&lang=ts&"
export * from "./multy-check.vue?vue&type=script&lang=ts&"
import style0 from "./multy-check.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports